import angular from 'angular';
import CategoryPagerToolboxDirective from './category-pager-toolbox.directive';

let CategoryPagerToolboxModule = angular.module('catalog.category.categoryPagerToolbox', [])
  .directive('categoryPagerToolbox', CategoryPagerToolboxDirective);

export default CategoryPagerToolboxModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/category/category-pager-toolbox/category-pager-toolbox.js
 **/